import React from "react";
import Link from "next/link";
import TermsContainer from "./TermsContainer";

export default function ReviewGuidelines() {
  return (
    <TermsContainer>
      <h2>Review Guidelines</h2>

      <p>
        Chic Beauty Box values and appreciates your feedback. When writing
        reviews, we ask that you stick to these general guidelines:
      </p>

      <ul>
        <li>Focus on the product and your individual experience using it</li>
        <li>Provide details about why you liked or disliked a product</li>
        <li>
          All submitted reviews are subject to the terms set forth below and in
          our{" "}
          <Link href="/terms">
            <a class="styled-underlined-link">Terms and Conditions</a>
          </Link>
        </li>
      </ul>

      <p>
        We reserve the right not to post your review if it contains any of the
        following types of content or violates other guidelines. By way of
        example, and not as a limitation, you agree that when posting reviews,
        you will not:
      </p>

      <ul>
        <li>
          Defame, abuse, harass, stalk, threaten or otherwise violate the legal
          rights (such as rights of privacy and publicity) of others
        </li>
        <li>
          Use obscenities, discriminatory language, or other language not
          suitable for a public forum
        </li>
        <li>
          Post advertisements, “spam” content, or references to other products,
          offers, or websites
        </li>
        <li>
          Post email addresses, URLs, phone numbers, physical addresses or other
          forms of contact information
        </li>
        <li>
          Post unduly critical or spiteful comments of other reviews posted on
          the page or their authors
        </li>
        <li>
          Post files that contain software or other material protected by
          intellectual property laws (or by rights of privacy of publicity)
          unless you own or control the rights thereto or have expressly
          received all necessary consents
        </li>
        <li>
          Post files or content that contain viruses, corrupted files, or any
          other similar software or programs that may damage the operation of
          another's computer
        </li>
        <li>
          Falsify or delete any author attributions, legal or other proper
          notices or proprietary designations or labels of the origin or source
          of software or other material contained in a file that is uploaded, or
          impersonate any person or entity or falsely state or misrepresent your
          affiliation with any person or entity
        </li>
      </ul>

      <p>
        In addition, if you wish to share feedback with us about product
        selection, pricing, ordering, delivery or other customer service issues,
        please do not submit this feedback through a product review. Instead,{" "}
        <a
          className="styled-underlined-link"
          href="https://help.chicbeautybox.com"
          target="_blank"
        >
          contact us
        </a>{" "}
        directly.
      </p>

      <p>Happy reviewing!</p>
    </TermsContainer>
  );
}
